import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import { constants } from 'components/byesign/ByesignHelper';
import MoveOutCreator from 'components/landlord_app/rent_roll/components/MoveOutCreator';

import { MuiThemeProvider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { AccentColor } from 'helpers/AccentColorHelper';
import { muiThemeNext } from 'helpers/MUIFiles';
import { featureEnabled } from 'helpers/ToggleBot';

import { colors } from 'helpers/ColorHelper';

import * as landlordTenantsActions from 'actions/landlordTenantsActions';
import { openDocument } from 'actions/landlordAPIDashboardActions';
import { openEditLease } from 'actions/LeaseDetailsActions';
import { openRenewalWizard } from '../renewals/store/actions';
import { getTranslatedString } from 'helpers/i18n';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

class OptionDetails extends Component {
  render() {
    const { disabled } = this.props;
    const style = {
      receipt_header: {
        margin: '0 0 10px 0',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '3px',
      },
      transaction_card: {
        color: '#424242 !important',
        fontFamily: '"Circular", sans-serif !important',
        height: '100%',
        overflow: 'hidden',
        borderRadius: '8px',
        padding: '10px 0',
      },
    };

    return (
      <div className="row" style={{ marginTop: '10px' }}>
        <MuiThemeProvider theme={muiThemeNext(disabled ? colors.GRAY : AccentColor())}>
          <Card style={style.transaction_card}>
            <CardText style={{ padding: '10px 25px' }}>
              <h3 style={{ textAlign: 'center', marginTop: '0px' }}>{this.props.optionsTitle}</h3>
              <p style={{ textAlign: 'justify' }}>{this.props.optionDetails}</p>
              <div className="row" style={{ textAlign: 'center' }}>
                <Button
                  aria-haspopup="true"
                  style={{
                    margin: '10px auto 0px',
                    backgroundColor: disabled ? colors.GRAY : AccentColor(),
                    color: 'white',
                    fontSize: '14px',
                  }}
                  disabled={disabled}
                  onClick={this.props.optionTrigger}
                >
                  {this.props.buttonVerbiage}
                </Button>
              </div>
            </CardText>
          </Card>
        </MuiThemeProvider>
      </div>
    );
  }
}

class LeaseOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCancellationDialog: false,
      cancellationReason: '',
      reasonRequiredError: false,
      showMoveOutDialog: false,
    };
  }

  toggleDocumentUploaderDialog = () => {
    this.props.toggleDocumentUploaderDialogOpen(!this.props.documentUploaderDialogOpen);
  };

  handleClose = () => {
    this.props.closePaymentPreference();
  };

  openPrePaymentsForm = () => {
    this.props.getPrePayments(this.props.leaseDetails.id);
    this.props.openPrePayments();
  };

  toggleMoveOutDialog = () => {
    this.setState(prevState => ({ showMoveOutDialog: !prevState.showMoveOutDialog }));
  };

  openLeaseDocuments = () => {
    this.props.openLeaseDocuments();
  };

  closeDocuments = () => {
    this.props.closeDocuments();
  };

  cancelLeaseTermination = () => {
    this.props.cancelLeaseTermination(this.props.leaseDetails.id).then(() => {
      this.props.openEditLease(this.props.leaseDetails.id);
      this.props.getRentRollData();
    });
  };

  toggleConfirmationDialog = () => {
    this.setState(prevState => ({ showCancellationDialog: !prevState.showCancellationDialog }));
  };

  deleteLease = async () => {
    this.setState({ reasonRequiredError: false });
    if (!this.state.cancellationReason) {
      this.setState({ reasonRequiredError: true });
      return;
    }

    await this.props.deleteLease(this.props.leaseDetails.id, this.state.cancellationReason);
    this.props.toggleDrawer();
    this.props.getRentRollData();
  };

  cancellationOnChange = (_e, _index, newValue) => {
    if (!newValue) {
      return;
    }

    this.setState({ cancellationReason: newValue });
  };

  viewMostRecentDocuments = () => {
    this.props.openDocument(constants.PRODUCTION, this.props.leaseDetails.document_uuid);
  };

  render() {
    return (
      <Fragment>
        <ConfirmationDialog
          showDialog={this.state.showCancellationDialog}
          hideDialog={this.toggleConfirmationDialog}
          userConfirmVerbiage={getTranslatedString('landlordPortal.leaseOptions.cancelLease')}
          dialogTitle={getTranslatedString('landlordPortal.leaseOptions.cancelLease')}
          dialogBodyVerbiage={this._renderCancelLease(this.state.cancellationReason)}
          userConfirmAction={this.deleteLease}
        />

        {this._renderModifyRenewal()}
        {this._renderLeaseOptions()}
        {this._renderCancelLeaseOption()}
      </Fragment>
    );
  }

  _renderCancelLeaseOption = () => {
    if (this.props.leaseDetails.expired) return;
    if (featureEnabled('ui.rent_roll_page.cancel_lease') && !this.props.leaseDetails.is_renewing)
      return;

    return (
      <OptionDetails
        optionsTitle={getTranslatedString('landlordPortal.rentRoll.cancelLease')}
        optionDetails={
          <p style={{ textAlign: 'justify' }}>
            {getTranslatedString('landlordPortal.rentRoll.cancelLease.description')} <br />
            <i className="em em-warning" />
            <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>
              {getTranslatedString('landlordPortal.rentRoll.cancelLease.warning')}
            </b>
            <i className="em em-warning" />
          </p>
        }
        optionTrigger={this.toggleConfirmationDialog}
        disabled={!this.props.leaseDetails.editable}
        buttonVerbiage={getTranslatedString('landlordPortal.rentRoll.cancelLease')}
      />
    );
  };

  _renderModifyRenewal = () => {
    if (!this.props.leaseDetails.is_renewing) return;

    return (
      <Fragment>
        <OptionDetails
          optionsTitle={getTranslatedString('landlordPortal.leaseOptions.modifyRenewal')}
          optionDetails={getTranslatedString('landlordPortal.leaseOptions.modifyRenewalDetails')}
          optionTrigger={() => this.props.triggerRenewal(this.props.leaseDetails.id)}
          buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.modifyRenewal')}
          disabled={!this.props.leaseDetails.editable}
        />
        {(this.props.leaseDetails.document_uuid || this.props.leaseDetails.lease_file_url) && (
          <OptionDetails
            optionsTitle={getTranslatedString('landlordPortal.leaseOptions.viewRecentDocument')}
            optionDetails={getTranslatedString(
              'landlordPortal.leaseOptions.viewRecentDocumentDetails'
            )}
            optionTrigger={this.viewMostRecentDocuments}
            buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.viewDocument')}
          />
        )}
      </Fragment>
    );
  };

  _renderLeaseOptions = () => {
    const { leaseDetails } = this.props;

    if (leaseDetails.is_renewing) return;
    if (leaseDetails.expired) {
      return this._renderViewDocumentsOption();
    }

    const yardiBased = !!leaseDetails.property && !!leaseDetails.property.yardi_based;

    return (
      <Fragment>
        <MoveOutCreator
          isOpen={this.state.showMoveOutDialog}
          toggleMoveOutDialog={this.toggleMoveOutDialog}
          toggleDrawer={this.props.toggleDrawer}
          getRentRollData={this.props.getRentRollData}
        />

        {!leaseDetails.renewed && (
          <Fragment>
            {/* property id check here is temporary fo FourStar */}
            {featureEnabled('yardi_renewals') &&
            (window.ENV !== 'production' || [492, 490, 491].includes(this.props.leaseDetails.property_id)) ? (
              <OptionDetails
                optionsTitle={getTranslatedString('landlordPortal.leaseOptions.renewWithNotice')}
                optionDetails={
                  <span>
                    <TenantResidentVerbiageHelper
                      translatedTenant={getTranslatedString(
                        'landlordPortal.leaseOptions.tenantRenewWithNoticeDetails'
                      )}
                      translatedResident={getTranslatedString(
                        'landlordPortal.leaseOptions.residentRenewWithNoticeDetails'
                      )}
                    />
                  </span>
                }
                optionTrigger={() => this.props.openRenewalWizard(leaseDetails.id)}
                buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.performRenewal')}
                disabled={!yardiBased || !leaseDetails.editable}
              />
            ) : (
              <OptionDetails
                optionsTitle={getTranslatedString('landlordPortal.leaseOptions.renewWithNotice')}
                optionDetails={
                  <span>
                    <TenantResidentVerbiageHelper
                      translatedTenant={getTranslatedString(
                        'landlordPortal.leaseOptions.tenantRenewWithNoticeDetails'
                      )}
                      translatedResident={getTranslatedString(
                        'landlordPortal.leaseOptions.residentRenewWithNoticeDetails'
                      )}
                    />
                  </span>
                }
                optionTrigger={() => this.props.triggerRenewal(leaseDetails.id, true)}
                buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.performRenewal')}
                disabled={!leaseDetails.editable}
              />
            )}

            <RenderIfToggleOn toggle="ui.rent_roll_page.manual_renewal">
              <OptionDetails
                optionsTitle={getTranslatedString('landlordPortal.leaseOptions.manualRenew')}
                optionDetails={
                  <span>
                    <TenantResidentVerbiageHelper
                      translatedTenant={getTranslatedString(
                        'landlordPortal.leaseOptions.tenantManualRenewDetails'
                      )}
                      translatedResident={getTranslatedString(
                        'landlordPortal.leaseOptions.residentManualRenewDetails'
                      )}
                    />
                  </span>
                }
                optionTrigger={() => {
                  const isManualRenewal = true;
                  return this.props.triggerRenewal(leaseDetails.id, true, isManualRenewal);
                }}
                buttonVerbiage={getTranslatedString(
                  'landlordPortal.leaseOptions.performManualRenewal'
                )}
                disabled={!leaseDetails.editable}
              />
            </RenderIfToggleOn>
          </Fragment>
        )}
        <RenderIfToggleOn toggle="ui.rent_roll_page.pre_payment">
          <OptionDetails
            optionsTitle={getTranslatedString(
              'landlordPortal.leaseOptions.prePaymentsOptionsTitle'
            )}
            optionDetails={getTranslatedString(
              'landlordPortal.leaseOptions.prePaymentsOptionDetails'
            )}
            optionTrigger={this.openPrePaymentsForm}
            buttonVerbiage={getTranslatedString(
              'landlordPortal.leaseOptions.prePaymentsButtonVerbiage'
            )}
          />
        </RenderIfToggleOn>
        <RenderIfToggleOn
          toggle="ui.rent_roll_page.perform_moveout"
          dontRenderIf={!!leaseDetails.move_out_date}
        >
          <OptionDetails
            optionsTitle={getTranslatedString('landlordPortal.leaseOptions.performMoveOut')}
            optionDetails={getTranslatedString('landlordPortal.rentRoll.moveOut')}
            optionTrigger={this.toggleMoveOutDialog}
            buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.performMoveOut')}
            disabled={!leaseDetails.editable || yardiBased}
          />
        </RenderIfToggleOn>
        <RenderIfToggleOn
          toggle="ui.rent_roll_page.perform_moveout"
          dontRenderIf={!leaseDetails.move_out_date}
        >
          <OptionDetails
            optionsTitle={getTranslatedString('landlordPortal.leaseOptions.cancelMoveOut')}
            optionDetails={getTranslatedString('landlordPortal.rentRoll.cancelMoveOut')}
            optionTrigger={this.cancelLeaseTermination}
            buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.cancelMoveOut')}
            disabled={!leaseDetails.editable}
          />
        </RenderIfToggleOn>
        {this._renderViewDocumentsOption()}
        <OptionDetails
          optionsTitle={getTranslatedString('landlordPortal.leaseOptions.uploadDocuments')}
          optionDetails={getTranslatedString('landlordPortal.leaseOptions.uploadDocumentsDetails')}
          optionTrigger={this.toggleDocumentUploaderDialog}
          buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.uploadDocuments')}
        />
      </Fragment>
    );
  };

  _renderViewDocumentsOption = () => (
    <OptionDetails
      optionsTitle={getTranslatedString('landlordPortal.leaseOptions.viewDocuments')}
      optionDetails={getTranslatedString('landlordPortal.leaseOptions.viewDocumentsDetails')}
      optionTrigger={this.openLeaseDocuments}
      buttonVerbiage={getTranslatedString('landlordPortal.leaseOptions.viewDocuments')}
    />
  );

  _renderCancelLease = cancellationReason => (
    <Fragment>
      <p> {getTranslatedString('landlordPortal.leaseOptions.cancelLeaseConfirmation')} </p>
      <div className="row" style={{ textAlign: 'initial' }}>
        <SelectField
          fullWidth
          value={cancellationReason}
          onChange={this.cancellationOnChange}
          errorText={
            this.state.reasonRequiredError &&
            getTranslatedString('landlordPortal.leaseOptions.required')
          }
          floatingLabelText={getTranslatedString(
            'landlordPortal.leaseOptions.reasonForCancellation'
          )}
        >
          <MenuItem
            key="0"
            primaryText={getTranslatedString('landlordPortal.leaseOptions.inputError')}
            value={'human_error'}
          />
          <MenuItem
            key="1"
            primaryText={
              <span>
                <TenantResidentVerbiageHelper
                  translatedTenant={getTranslatedString(
                    'landlordPortal.leaseOptions.tenantCancelledPrior'
                  )}
                  translatedResident={getTranslatedString(
                    'landlordPortal.leaseOptions.residentCancelledPrior'
                  )}
                />
              </span>
            }
            value={'tenant_cancelled'}
          />
          <MenuItem
            key="2"
            primaryText={
              <span>
                <TenantResidentVerbiageHelper
                  translatedTenant={getTranslatedString(
                    'landlordPortal.leaseOptions.tenantEvicted'
                  )}
                  translatedResident={getTranslatedString(
                    'landlordPortal.leaseOptions.residentEvicted'
                  )}
                />
              </span>
            }
            value={'eviction'}
          />
          <MenuItem
            key="3"
            primaryText={
              <span>
                <TenantResidentVerbiageHelper
                  translatedTenant={getTranslatedString(
                    'landlordPortal.leaseOptions.tenantSkipped'
                  )}
                  translatedResident={getTranslatedString(
                    'landlordPortal.leaseOptions.residentSkipped'
                  )}
                />
              </span>
            }
            value={'tenant_skip'}
          />
          <MenuItem
            key="4"
            primaryText={getTranslatedString('landlordPortal.leaseOptions.nonPaymentRent')}
            value={'non_payment_rent'}
          />
        </SelectField>
      </div>
    </Fragment>
  );
}

export default connect(
  store => ({
    leaseDetails: store.leaseDetails.leaseDetails,
    documentUploaderDialogOpen: store.landlordTenants.documentUploaderDialogOpen,
  }),
  {
    ...landlordTenantsActions,
    openDocument,
    openEditLease,
    openRenewalWizard,
  }
)(LeaseOptions);
